import styled from "styled-components";

export const ContLogo = styled.div`
   .styleContLogo {
      width: 100%;
      height: 120px;
      margin: 12px 0px 12px 0px;
   }

   .styleLogo {
      margin-left: auto;
      margin-right: auto;
      display: block;
   }
`;
